// PolicyLanguageForm.js
import React, { useEffect, useState } from "react";
import {
  Box,
  InputLabel,
  TextField,
  Select,
  MenuItem,
  // FormControl,
  // FormLabel,
  // RadioGroup,
  // FormControlLabel,
  // Radio,
  Paper,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import ButtonCommon from "../../CommonComponent/ButtonCommon";
import { getAllLanguages } from "../../api/websiteService";

const GeneralSettings = ({
  formData,
  setFormData,
  handleInputChange,
  onNext,
  isFrameworksLoading,
  frameworks,
  errors,
  isEditing,
}) => {
  // Update available languages when framework changes
  const [availableLanguages, setAvailableLanguages] = React.useState([]);
  const [isLanguagesLoading, setIsLanguagesLoading] = useState(false);

  useEffect(() => {
    const fetchAndFilterLanguages = async () => {
      if (formData.framework_id && frameworks.length > 0) {
        const selectedFramework = frameworks.find(
          (framework) => framework.framework_id === formData.framework_id
        );

        if (selectedFramework?.supported_languages) {
          const supportedLangCodes = selectedFramework.supported_languages;
          // Reset selected language
          setFormData((prev) => ({ ...prev, language: "" }));
          setIsLanguagesLoading(true);
          try {
            const allLanguages = await getAllLanguages();
            // ✅ Step 3: Filter based on supported codes
            if (allLanguages.status_code === 200) {
              const filteredLanguages = allLanguages.data.filter((lang) =>
                supportedLangCodes.includes(lang.language_code)
              );
              // ✅ If only one language is available, set it by default
              if (filteredLanguages.length === 1) {
                setFormData((prev) => ({
                  ...prev,
                  language: filteredLanguages[0].language_code,
                }));
              }
              setAvailableLanguages(filteredLanguages);
            }
          } catch (error) {
            console.error("Error fetching languages:", error);
          } finally {
            setIsLanguagesLoading(false);
          }
        }
      }
    };
    fetchAndFilterLanguages();
    // eslint-disable-next-line
  }, [formData.framework_id, frameworks]);

  return (
    <Paper elevation={2} sx={{ p: 4, mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <InputLabel
          htmlFor="policy_name"
          required
          sx={{
            mb: 1,
            "& .MuiFormLabel-asterisk": {
              color: "red",
            },
          }}
        >
          Policy Name
        </InputLabel>
        <TextField
          fullWidth
          required
          id="policy_name"
          name="policy_name"
          value={formData?.policy_name || ""}
          onChange={handleInputChange}
          placeholder="Privacy Policy"
          size="small"
          autoComplete="off"
          error={!!errors?.policy_name}
          helperText={errors?.policy_name}
        />
      </Box>

      <Box sx={{ mt: 3, mb: 3 }}>
        <InputLabel
          id="framework-label"
          required
          sx={{
            mb: 1,
            "& .MuiFormLabel-asterisk": {
              color: "red",
            },
          }}
        >
          Select Framework
        </InputLabel>
        {isFrameworksLoading ? (
          <CircularProgress size={24} />
        ) : (
          <>
            <Select
              labelId="framework-label"
              id="framework-select"
              name="framework_id"
              value={formData?.framework_id}
              onChange={handleInputChange}
              fullWidth
              size="small"
              error={!!errors?.framework_id}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
              }}
              disabled={isEditing}
            >
              <MenuItem value="">Select a framework</MenuItem>

              {(Array.isArray(frameworks) ? frameworks : [])
                .filter(
                  (framework) =>
                    framework.framework_name === "Generic Cookie Banner" &&
                    (!framework.has_policy || framework.framework_id === formData.framework_id)
                )
                .map((framework) => (
                  <MenuItem key={framework.framework_id} value={framework.framework_id}>
                    {framework.framework_name}
                  </MenuItem>
                ))}
            </Select>

            {errors?.framework_id && (
              <FormHelperText error>{errors.framework_id}</FormHelperText>
            )}
          </>
        )}
      </Box>

      <Box sx={{ mt: 3, mb: 3 }}>
        <InputLabel
          id="language-label"
          required
          sx={{
            mb: 1,
            "& .MuiFormLabel-asterisk": {
              color: "red",
            },
          }}
        >
          Select Language
        </InputLabel>
        {isLanguagesLoading ? (
          <CircularProgress size={24} />
        ) : availableLanguages.length === 1 ? (
          // ✅ Only one language, show it as plain text (or disabled select)
          <TextField
            value={availableLanguages[0].language_description}
            fullWidth
            size="small"
            disabled
          />
        ) : (
          <>
            <Select
              labelId="language-label"
              id="language-select"
              name="language"
              value={formData?.language}
              onChange={handleInputChange}
              fullWidth
              size="small"
              error={!!errors?.language}
              MenuProps={{
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                transformOrigin: { vertical: "top", horizontal: "left" },
              }}
              disabled={isEditing}
            >
              <MenuItem value="">Select a language</MenuItem>
              {availableLanguages.map((lang) => (
                <MenuItem key={lang.language_code} value={lang.language_code}>
                  {lang.language_description}
                </MenuItem>
              ))}
            </Select>
            {errors?.language && (
              <FormHelperText error>{errors.language}</FormHelperText>
            )}
          </>
        )}
      </Box>

      {/* <Box sx={{ mt: 3, mb: 3 }}>
        <FormControl component="fieldset" error={!!errors?.hosting_preference}>
          <FormLabel component="legend">Hosting Preference</FormLabel>
          <RadioGroup
            aria-label="hosting-preference"
            id="hosting-preference"
            name="hosting_preference"
            value={formData?.hosting_preference}
            onChange={handleInputChange}
            row
          >
            <FormControlLabel
              value="website"
              control={<Radio id="radio-website" />}
              label="Website"
            />
            <FormControlLabel
              value="dpc"
              control={<Radio id="radio-dpc" />}
              label="DPC"
            />
            <FormControlLabel
              value="both"
              control={<Radio id="radio-both" />} 
              label="Both"
            />
          </RadioGroup>
          {errors?.hosting_preference && (
            <FormHelperText error>{errors.hosting_preference}</FormHelperText>
          )}
        </FormControl>
      </Box> */}

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <ButtonCommon onClick={onNext}>Next</ButtonCommon>
      </Box>
    </Paper>
  );
};

export default GeneralSettings;
